/**
 * Pearla 品牌 - Home 页面配置
 */
import { homeCommonConfig } from './common'
import type { HomePageConfig } from './types'

/**
 * Pearla 品牌主题配置
 */
export const theme = {
  // 首页背景图
  homeBg: '/images/pearla/home-bg.webp',
  // 标签模块背景图
  tagsBg: '/images/pearla/tag-background.webp',

  // 标签按钮选中状态 (使用品牌主色)
  tagActiveBg: '#AB75FB',
  tagActiveText: '#FFFFFF',

  // 标签按钮未选中状态
  tagInactiveBg: '#F5F0FF',
  tagInactiveText: '#AB75FB',

  // Tab 激活状态渐变底部装饰线
  tabActiveGradient: 'linear-gradient(270deg, #F6F7F9 0%, #AB75FB 95%)',
  // Tab 激活状态文字和下划线颜色
  tabActiveColor: '#AB75FB',
  // sticky-header 背景渐变
  stickyHeaderBg: 'linear-gradient(180deg, #F3EAFF 0%, #FFFFFF 100%)',
} as const

export const homeConfig: HomePageConfig = {
  theme,
  texts: homeCommonConfig.texts,
}
